import { Box } from "@mui/material";

import Header from "../../components/Header";
//import DataGrid from "devextreme-react/data-grid";

import { useState } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";

import { useDispatch, useSelector } from "react-redux";

import VehicleCountMarkList from "../../components/reports/vehicle_count_mark_report/vehicle_count_mark_report_list";

const VehicleCountMarkRepoprt = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [isCompanyFilter, setIsCompanyFilter] = useState(false);
  const [compName, setCompanyName] = useState("");

  return (
    <Box m="20px">
      <Header
        title="Нийтийн тээврийн автобусны маркаар тайлан"
        subtitle="Нийтийн тээврийн автобусны марк /үндсэн. Буухиа. Такси. Хүүхдийн автобус. Ажилчдын автобус/ тайлан"
      />

      <Box
        display="grid"
        gap="30px"
        gridTemplateColumns="repeat(12, minmax(0, 1fr))"
        sx={{
          "& > div": { gridColumn: isNonMobile ? undefined : "span 12" },
        }}
      >
        {/* <Box sx={{ gridColumn: "span 3" }}>
          <FilterBox getFilters={setFilters} />
        </Box> */}
        <Box sx={{ gridColumn: "span 12" }}>
          <VehicleCountMarkList
          //  porkurorReportListData={getViolationDetectionReportData}
          // comptData={compName}
          //  isCompanyFilter={isCompanyFilter}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default VehicleCountMarkRepoprt;
